<template>

    <spinner-until :condition="!showSpinner">

        <div class="survey-responses mx-3 mt-page"
             v-if="!showSpinner">

            <h1 class="mb-3">
                {{ $i18n.gt('HEADING_SURVEY_RESPONSES') }}
                ({{ $i18n.gt(`QUESTIONNAIRE_TITLE_${survey.questionnaire_code}`) }})
            </h1>

            <div v-for="section in survey.questionnaire.sections" :key="section.name">
                <h3>
                    {{ $i18n.gt(`QUESTIONNAIRE_${survey.questionnaire_code}_SECTION_${section.name}_TITLE`) }}
                </h3>
                <b-card no-body
                        v-for="question in getQuestionsForSection(section)" :key="question ? question.name : ''">
                    <b-card-body class="p-0 pt-md-0">
                        <div class="survey-responses__entry">
                            <div class="survey-responses__question p-md-3"
                                 v-html="$i18n.translateQuestionField(question, 'QUESTION_TEXT')">
                            </div>

                            <template v-if="question.type !== 'MULTI_SELECT_ONE'">
                                <div v-for="(line, i) in getResponseDisplay(question)" :key="i"
                                     class="text-center py-3 survey-responses__answer">

                                    <strong v-html="line">
                                    </strong>

                                </div>
                            </template>
                            <template v-else>
                                <div v-for="(line, i) in getResponseDisplay(question)" :key="i"
                                     class="text-center py-3 survey-responses__answer">

                                    <div v-for="(ans, j) in line" :key="j"
                                         class="py-3 survey-responses__answer"
                                         style="width: unset;">
                                        <strong v-if="question.multi_options[j][0] !== 'A'" v-html="ans">
                                        </strong>
                                        <strong v-else>
                                            {{$i18n.gt(`QUESTION_RTC_RTC_OPTION_${ans.charCodeAt(0)-65}`)}}
                                        </strong>
                                    </div>
                                </div>
                            </template>

                        </div>
                    </b-card-body>
                </b-card>
            </div>

        </div>

    </spinner-until>

</template>

<!-- -------------------------------------------------------- -->

<script>
import Vue from 'vue'
import * as _ from 'lodash'
import moment from 'moment'

/**
 * Page for practitioner to review responses to a Survey
 */
export default Vue.extend({
    name: 'SurveyResponses',
    props: {
        surveyId: Number,
    },
    data() {
        return {
            showSpinner: true,
            survey: {}
        }
    },
    methods: {
        loadSurvey() {
            this.$store.dispatch('getSurvey', {surveyId: this.surveyId})
                .then((survey) => {
                    this.survey = this.$store.state.survey
                    this.showSpinner = false
                })
        },
        getQuestionsForSection(section) {
            const questions = _.map(section.question_names, (qname) => {
                return _.find(this.survey.questionnaire.questions, (q) => q.name === qname) ||
                    _.find(this.survey.questionnaire.scores, (q) => q.name === qname)
            })
            return _.filter(questions, (q) => {
                return q.type != 'INSTRUCTIONS'
            })
        },
        getResponseDisplay(question) {
            const lines = []
            if (question.type == 'ENTER_DATA') {
                const template = this.translateQuestionField(question, `OPTIONS_0`)
                const response = question.response.optionValuesList[0]
                if (!!response && template.indexOf('__') != -1) {
                    lines.push(template.replace('__', response))
                } else {
                    lines.push(response)
                }
            } else if (question.type == 'SELECT_ONE') {
                const rValue = question.response.optionValuesList[0] // e.g. "r_0"
                if (rValue) {
                    const i = rValue.replace('r_', '')
                    lines.push(this.translateQuestionField(question, `OPTIONS_${i}`))
                } else {
                    return []
                }
            } else if (question.type == 'SCALE') {
                const rValue = question.response.optionValuesList[0] // e.g. "r_0"
                if (rValue) {
                    const i = rValue.replace('r_', '')
                    lines.push(Number(i) + 1)
                } else {
                    return []
                }
            } else if (question.type == 'SELECT_ANY') {
                _.each(question.options, (opt, i) => {
                    if (question.response.optionValuesList[i]) {
                        lines.push(this.translateQuestionField(question, `OPTIONS_${i}`))
                    }
                })
            } else if (question.type == 'MULTI_SELECT_ONE') {
                _.each(question.options, (opt, i) => {
                    if (question.response.optionValuesList[i]) {
                        let answers = []
                        _.each(question.response.optionValuesList, (opt, j) => {
                            answers.push(question.multi_options[j][opt.replace('r_', '')])
                        })
                        lines.push(answers)
                    }
                })
            }
            return lines
        },
        translateQuestionField(question, field) {
            return this.$i18n.gt(`QUESTION_${question.name}_${field}`)
        },
    },
    created() {
        this.loadSurvey()
    },
})

</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">

@import '../../sass/variables_mixins';

.survey-responses {
    max-width: 900px;

    .section-header {
        th, td {
            background-color: lightblue;
        }
    }

    @media(min-width: 768px) {
        .card-body {

        }
    }

}

.survey-responses__entry {
    @media(min-width: 768px) {
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        &:after {
            content: '';
            display: block;
            position: absolute;
            z-index: 0;
            background-color: var(--light-blue);
            right: 0;
            top: 0;
            width: 20%;
            height: 100%;
        }
    }
}

.survey-responses__question {
    padding: 15px;
    background-color: #fff;
    @media(min-width: 768px) {
        width: 80%;
    }
}

.survey-responses__answer {
    height: 100%;
    background-color: var(--light-blue);
    color: #fff;
    border-radius: 0 0 4px 4px;
    padding: 15px;
    @media(min-width: 768px) {
        width: 20%;
        border-radius: 0 4px 4px 0;
        position: relative;
        z-index: 2;
    }
}


</style>
